import React from 'react';
import { FaEye, FaBullseye, FaLightbulb, FaCheckCircle } from 'react-icons/fa';

const About = () => {
  const values = [
    {
      icon: <FaEye />,
      title: 'Notre vision',
      text: 'Être un acteur majeur du développement technologique et économique en Afrique, en concevant des solutions innovantes qui transforment les secteurs d\'activité et créent des opportunités durables.',
    },
    {
      icon: <FaBullseye />,
      title: 'Notre mission',
      text: 'Combiner technologie, ingénierie et expertise professionnelle pour concevoir des solutions concrètes adaptées aux réalités africaines, créer de la valeur et accompagner la transformation des entreprises et des communautés.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Notre approche',
      text: 'Une démarche centrée sur l\'écoute, l\'innovation et l\'impact. Nous transformons les idées, les compétences et les besoins réels en solutions capables de générer des opportunités et de la croissance.',
    },
  ];

  const points = [
    'Solutions adaptées au contexte africain',
    'Expertise pluridisciplinaire (tech, ingénierie, agriculture)',
    'Innovation continue et veille technologique',
    'Engagement envers la qualité et l\'impact social',
  ];

  return (
    <section id="apropos" className="about section">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">À propos</span>
          <h2 className="section-title">Une entreprise de développement social, technologique et économique</h2>
          <p className="section-subtitle">
            Livia Tech est une entreprise congolaise qui conçoit et développe des solutions
            technologiques, numériques et professionnelles adaptées aux réalités africaines.
            Nous combinons innovation, ingénierie et expertise pour transformer les secteurs d'activité
            et créer des opportunités.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-values">
            {values.map((value, index) => (
              <div className="about-value-card" key={index}>
                <div className="about-value-icon">{value.icon}</div>
                <div className="about-value-content">
                  <h3>{value.title}</h3>
                  <p>{value.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="about-side">
            <div className="about-visual about-visual-image">
              <img
                src="/images/solutions.jpeg"
                alt="Livia Tech — Solutions technologiques & innovation"
                className="about-visual-img"
                loading="lazy"
              />
              <div className="about-visual-overlay"></div>
              <div className="about-visual-content">
                <h3>Livia Tech</h3>
                <p>Solutions technologiques & innovation</p>
              </div>
            </div>
            <div className="about-points">
              {points.map((point, index) => (
                <div className="about-point" key={index}>
                  <FaCheckCircle className="about-point-icon" />
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;